import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from './TopNav';
import Footer from './Footer';

const MediaPage = () => {
  const categories = [
    {
      id: 'photography',
      title: 'Photography',
      description: 'Captured moments and perspectives',
      path: '/media/photography',
      icon: '📷'
    },
    {
      id: 'videography',
      title: 'Videography',
      description: 'Motion pictures and visual stories',
      path: '/media/videography',
      icon: '🎬'
    }
  ];

  return (
    <div className="media-page">
      <TopNav />
      <div className="media-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="page-title">Media</h1>
        <p className="page-subtitle">Visual content and creative work</p>
        
        <div className="categories-grid">
          {categories.map((category) => (
            <Link 
              to={category.path} 
              key={category.id} 
              className="category-card"
            >
              <span className="category-icon">{category.icon}</span>
              <h2 className="category-title">{category.title}</h2>
              <p className="category-description">{category.description}</p>
              <span className="category-arrow">→</span>
            </Link>
          ))}
        </div>
        
        <Footer />
      </div>

      <style jsx>{`
        .media-page {
          min-height: 100vh;
          background: #151312;
          padding: 40px 20px;
        }

        .media-container {
          max-width: 900px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: calc(100vh - 80px);
        }

        .back-link {
          align-self: flex-start;
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: #f46c38;
          text-decoration: none;
          margin-bottom: 40px;
          transition: opacity 0.2s ease;
        }

        .back-link:hover {
          opacity: 0.8;
        }

        .page-title {
          font-family: 'Poppins', sans-serif;
          font-size: 48px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 12px;
          text-align: center;
        }

        .page-subtitle {
          font-family: 'Poppins', sans-serif;
          font-size: 16px;
          color: #998f8f;
          margin-bottom: 48px;
          text-align: center;
        }

        .categories-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          width: 100%;
        }

        .category-card {
          background: rgba(182, 180, 189, 0.08);
          border: 1px solid rgba(182, 180, 189, 0.15);
          border-radius: 16px;
          padding: 40px 32px;
          text-decoration: none;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          position: relative;
        }

        .category-card:hover {
          background: rgba(182, 180, 189, 0.12);
          border-color: rgba(244, 108, 56, 0.3);
          transform: translateY(-4px);
        }

        .category-icon {
          font-size: 48px;
          margin-bottom: 20px;
        }

        .category-title {
          font-family: 'Poppins', sans-serif;
          font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 8px;
        }

        .category-description {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: #998f8f;
          margin-bottom: 16px;
        }

        .category-arrow {
          font-size: 20px;
          color: #f46c38;
          transition: transform 0.2s ease;
        }

        .category-card:hover .category-arrow {
          transform: translateX(4px);
        }

        @media (max-width: 768px) {
          .media-page {
            padding: 20px 16px;
          }

          .media-container {
            min-height: calc(100vh - 40px);
          }

          .page-title {
            font-size: 32px;
          }

          .page-subtitle {
            font-size: 14px;
            margin-bottom: 32px;
          }

          .back-link {
            margin-bottom: 24px;
          }

          .categories-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .category-card {
            padding: 32px 24px;
          }

          .category-icon {
            font-size: 40px;
          }

          .category-title {
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default MediaPage;
